import type { LoadBalancingWorkerSkillsQueryCgResponse } from '@common/graphql';
import {
  sortSkillsByName,
  type WorkerSkillType,
} from '@load-balancing/services';

export function skillsFromWorkerSkills(
  data?: LoadBalancingWorkerSkillsQueryCgResponse
): WorkerSkillType[] {
  return sortSkillsByName(data?.loadBalancingWorker.skills ?? []);
}
